import {styled} from '@mui/material/styles';
import {Button} from "@mui/material";

/**
 * A 'fixed' box that covers the entire screen
 */
const StyledButton = styled(Button)(({theme}) => ({
    border: "1px solid #ddd",
    backgroundImage: "linear-gradient(to bottom, #fff, #eee)",
    color: "#888",
    "&:hover, &:active": {
        color: "#777",
        backgroundImage: "linear-gradient(to bottom, #fff, #e6e6e6)",
    }
}));

export {StyledButton}